const config = {
    API: '/api', // uses the relative path to access the API in production
    OIDC: {
        clientID: 'datacasting',
        authority: 'https://id.qa.globoi.com/auth/realms/globoi',
    }
}

const isLocalDevelopment = window.location.host.startsWith('localhost');
const isProduction = window.location.host.startsWith('datacasting.dtv.globo');


if (isLocalDevelopment) {
    config.API = '/api'
}

if (isProduction) {
    config.OIDC.authority = 'https://login.g.globo/auth/realms/globoi'
}

export { config }
